var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5C19.4497 16.5 20.625 15.3247 20.625 13.875C20.625 12.4253 19.4497 11.25 18 11.25C16.5503 11.25 15.375 12.4253 15.375 13.875C15.375 15.3247 16.5503 16.5 18 16.5Z",
    fill: "#333333",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 24.3V24.75H24.75V24.3C24.75 22.6198 24.75 21.7798 24.423 21.138C24.1354 20.5735 23.6765 20.1146 23.112 19.827C22.4702 19.5 21.6301 19.5 19.95 19.5H16.05C14.3698 19.5 13.5298 19.5 12.888 19.827C12.3235 20.1146 11.8646 20.5735 11.577 21.138C11.25 21.7798 11.25 22.6198 11.25 24.3Z",
    fill: "#333333",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.440fe9728e3be3b57bc97b8bfaa30a23.svg";
export { ForwardRef as ReactComponent };